import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProjectConfiguration, ProjectId } from '@models/ProjectConfiguration';
import { UserProfile } from '@models/UserProfile';
import { SynchronizerService } from '../synchronizer.service';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { MarkedPipe } from '../marked.pipe';
import { CommonTasksService } from '../common-tasks.service';

@Component({
  selector: 'app-myprojects',
  imports: [CommonModule,
    MatListModule,
    RouterModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatCardModule,
    MarkedPipe
  ],
  templateUrl: './myprojects.component.html',
  styleUrl: './myprojects.component.scss'
})
export class MyprojectsComponent {
  projects: ProjectConfiguration[] = [];

  constructor(
    private synchronizerService: SynchronizerService,
    public dialog: MatDialog,
    public commonTasks: CommonTasksService,
  ) {
    this.synchronizerService.user$.subscribe((user: UserProfile | undefined) => {
      if (user) {
        this.projects = Array.from(user.projects || []).sort((a: ProjectConfiguration, b: ProjectConfiguration) => b.title.localeCompare(a.title)).reverse();
      } else {
        this.projects = [];
      }
    });
  }

  get user(): UserProfile | undefined {
    return this.synchronizerService.user$.value;
  }

  changeProject(pid: ProjectId) {
    const project = this.user?.project(pid);
    if (project) {
      this.synchronizerService.setProject(pid, project.fallbackCanon());
    }
  }

}
